<template>
  <div>
    <NBar title="个人中心" :top="true" :right-show="true" :on-click-home="home"/>
    <div class="top-bg">
      <div class="user-info">
        <div class="avatar-div">
          <img class="avatar" :src='user.avatar ? user.avatar : require("@/resource/img/device/headImg.png")'/>
        </div>
        <div class="name">
          <span>{{user.nickname || '用户'}}</span>
        </div>
        <div class="top-money-div">
          <div class="top-item-div">
            <span class="txt">我的余额(元)</span>
            <nut-price :price="user.cardMoney" style="color: #ff2206;" :decimalDigits="2"
                       :needSymbol="true" :thousands="true"/>
          </div>
          <img class="long-string-img" :src='require("@/resource/img/device/long_string_icon.png")'/>
          <div class="top-left-div" @click="$router.push('/device/DeviceRecharge')">
            <span class="money">立即充值</span>
            <img class="recharge-img" :src='require("@/resource/img/device/icon_recharge.png")'/>
          </div>
        </div>
        <div class="top-money-div" style="padding-bottom: 10px;">
          <div class="top-left-div" @click="$router.push('/device/DeviceYearCard')">
            <div class="top-left-div" v-if="config.cardId != null" style="flex: 0.7;">
              <img class="year-img" :src='require("@/resource/img/device/year_icon.png")'/>
              <span class="txt">{{config.cardEndTime}}到期</span>
            </div>
            <div class="top-left-div" v-else style="flex: 0.7;">
              <img class="year-img" :src='require("@/resource/img/device/gray_year_icon.png")'/>
              <span class="txt">去开通</span>
            </div>
            <img class="arrow-img" :src='require("@/resource/img/device/arrow-right.png")'/>
          </div>
        </div>
      </div>
    </div>
    <div class="item-div">
      <nut-cell :show-icon="true" title="充值明细" style="margin: 0px 15px;border-radius: 5px;"
                @click-cell="$router.push('/device/DeviceRechargeRecord')">
        <div slot="avatar">
          <img :src='require("@/resource/img/device/recharge_pic.png")'
               style="width:26px;height:26px;margin-right: 12px;"/>
        </div>
      </nut-cell>
      <nut-cell :show-icon="true" title="消费记录" style="margin: 0px 15px;border-radius: 5px;"
                @click-cell="$router.push('/device/DeviceOrderRecord')">
        <div slot="avatar">
          <img :src='require("@/resource/img/device/consume_icon.png")'
               style="width:23px;height:19px;margin-right: 12px;"/>
        </div>
      </nut-cell>
    </div>
  </div>
</template>

<script>
/**
 * 顾客详情
 */
export default {
  name: 'DeviceCustom',
  data () {
    return {
      user: {},
      config: {},
    }
  },
  mounted () {
    this.user = this.$api.user
    this.config = this.$api.user.configCode === 1 ? this.$api.user.config : {}
  },
  methods: {
    home () {
      let deviceId = localStorage.getItem('deviceId')
      this.$router.push(`/device/DeviceUse?deviceId=${deviceId}`)
    }
  }
}
</script>

<style scoped>

  .top-bg {
    height: 101px;
    padding: 30px 0;
    border-radius: 0 0 40% 40%;
    background: linear-gradient(180deg, #FF565C 0%, #FF874A 100%);
    z-index: 100;
  }


  .top-bg .user-info {
    position: absolute;
    display: flex;
    flex-direction: column;
    background-color: white;
    left: 15px;
    right: 15px;
    top: 80px;
    border-radius: 10px;
    min-height: 150px;
    box-shadow: 0 1px 10px 0 rgba(255, 134, 74, 0.4);
  }

  .top-bg .avatar-div {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: white;
    padding: 5px;
    position: absolute;
    top: -30px;
  }

  .top-bg .avatar-div .avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .top-bg .user-info .name {
    line-height: 25px;
    font-size: 14px;
    margin: 15px 15px 0 87px;
  }

  .top-bg .user-info .top-money-div {
    margin: 15px 25px 0 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .top-bg .user-info .top-money-div .long-string-img {
    width: 1px;
    height: 22px;
  }

  .top-bg .user-info .top-item-div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .top-bg .user-info .top-left-div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .top-bg .user-info .top-left-div .recharge-img {
    width: 13px;
    height: 13px;
    margin-left: 5px;
  }

  .top-bg .user-info .top-left-div .year-img {
    width: 25px;
    height: 25px;
    margin-right: 20px;
  }

  .top-bg .user-info .top-left-div .arrow-img {
    width: 25px;
    height: 25px;
  }

  .top-bg .user-info .txt {
    line-height: 16px;
    color: #4a4a4a;
    span-align: center;
  }

  .item-div {
    margin: 50px 10px 10px;
    background-color: white;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/use/DeviceCustom.vue